import { Link } from '@tanstack/react-router'
import { Button } from '@trellis/roots/button'
import { Typography } from '@trellis/roots/typography'

interface ExpenseNotFoundProps {
  title: string
  description: string
}

export function ExpenseNotFound({ title, description }: ExpenseNotFoundProps) {
  return (
    <div className="mx-auto max-w-[800px] p-8 text-center">
      <Typography variant="h4" as="h1" className="mb-2">
        {title}
      </Typography>
      <Typography variant="body" color="muted" className="mb-6">
        {description}
      </Typography>
      <Button asChild variant="outline">
        <Link to="/expenses">Back to expenses</Link>
      </Button>
    </div>
  )
}
